<template>
  <div class="page-flip absolute inset-0 pointer-events-none z-[200] overflow-hidden" v-show="isAnimating">
    <div class="page-flip__line absolute top-0 bottom-0 w-[3px]" ref="line"></div>
  </div>
</template>

<script>
import { gsap } from 'gsap'

export default {
  name: 'PageFlip',

  data() {
    return { isAnimating: false }
  },

  methods: {
    _sweepOnce(direction, duration) {
      return new Promise((resolve) => {
        const line = this.$refs.line

        if (direction === 'forward') {
          gsap.set(line, { right: '0%', left: 'auto', x: '100%' })
          gsap.to(line, {
            x: '0%',
            duration: duration * 0.5,
            ease: 'power2.in',
            onComplete: () => {
              gsap.to(line, {
                x: '-100vw',
                duration: duration * 0.5,
                ease: 'power2.out',
                onComplete: resolve,
              })
            },
          })
        } else {
          gsap.set(line, { left: '0%', right: 'auto', x: '-100%' })
          gsap.to(line, {
            x: '0%',
            duration: duration * 0.5,
            ease: 'power2.in',
            onComplete: () => {
              gsap.to(line, {
                x: '100vw',
                duration: duration * 0.5,
                ease: 'power2.out',
                onComplete: resolve,
              })
            },
          })
        }
      })
    },

    async play(direction = 'forward', pageCount = 1, isMobile = false) {
      this.isAnimating = true

      const baseDuration = isMobile ? 0.22 : 0.3
      const midDuration  = 0.12
      const interval     = isMobile ? 20 : 30

      if (pageCount <= 1) {
        await this._sweepOnce(direction, baseDuration)
      } else {
        for (let i = 0; i < pageCount; i++) {
          const dur = (i === 0 || i === pageCount - 1) ? baseDuration : midDuration
          await this._sweepOnce(direction, dur)
          if (i < pageCount - 1) {
            await new Promise(r => setTimeout(r, interval))
          }
        }
      }

      this.isAnimating = false
    },
  },
}
</script>

<style lang="scss" scoped>
.page-flip__line {
  background: linear-gradient(to bottom,
    transparent 0%,
    rgba(255, 255, 255, 0.15) 10%,
    rgba(255, 255, 255, 0.9) 50%,
    rgba(255, 255, 255, 0.15) 90%,
    transparent 100%
  );
  box-shadow: 0 0 12px 4px rgba(255, 255, 255, 0.4);
  will-change: transform;
}
</style>
